<template>
  <div
    class="m-pc-metting-schedule top-nav new"
    id="schedule"
    v-if="extras.groupAgendaDisplay.display == 1"
    :style="{
      background:
        extras.agendaBg.colorOrBg == 'color'
          ? extras.agendaBg.color
          : 'url(' + extras.agendaBg.src + ')',
    }"
  >
    <div class="pc-metting-content u-w1200">
      <Title
        v-if="extras.scheduleTitle.display == 1"
        :title="extras.scheduleTitle.mainTitle || title"
        :en="extras.scheduleTitle.subTitle || 'AGENDA'"
        :extras="extras"
      />
      <div class="pc-agendas-info">
        <div class="pc-content-info" v-if="agendas.length > 0">
          <swiper
            v-if="agendas.length > 4"
            :options="swiperOptions"
            class="pc-metting-time new"
          >
            <swiper-slide
              class="date-new swiper-slide"
              :class="{
                'cursor-default': isSetting == 1,
                active: item.agendaDate == currentId,
              }"
              v-for="(item, index) in agendas"
              :key="index"
              :style="{
                background:
                  item.agendaDate == currentId
                    ? extras.agendaSetting.angendaDayBgActive == 'src'
                      ? 'url(' + extras.agendaSetting.src + ')'
                      : extras.agendaSetting.color
                    : extras.agendaSetting.angendaDayBg == 'src'
                    ? 'url(' + extras.agendaSetting.imgUrl + ')'
                    : extras.agendaSetting.color2,
              }"
            >
              <!--<div class="date-cnt" @click="DayClick(item)">-->
              <!--<span :class="{ active: item.agendaDate == currentId }">{{-->
              <!--item.agendaDate | formatDate-->
              <!--}}</span>-->
              <!--</div>-->
              <div class="date-cnt-new" :class="{}" @click="DayClick(item)">
                <div
                  class="title"
                  :style="{
                    color:
                      item.agendaDate == currentId
                        ? extras.agendaSetting.text4 == 'custom'
                          ? extras.agendaSetting.fontColor4 + ' !important'
                          : ''
                        : extras.agendaSetting.text3 == 'custom'
                        ? extras.agendaSetting.fontColor3
                        : '',
                    'font-size':
                      item.agendaDate == currentId
                        ? extras.agendaSetting.text4 == 'custom'
                          ? extras.agendaSetting.fontSize4 + 'px'
                          : ''
                        : extras.agendaSetting.text3 == 'custom'
                        ? extras.agendaSetting.fontSize3 + 'px'
                        : '',
                    'font-style':
                      item.agendaDate == currentId
                        ? extras.agendaSetting.text4 == 'custom'
                          ? extras.agendaSetting.fontTilt4 == 'on'
                            ? 'italic'
                            : 'normal'
                          : ''
                        : extras.agendaSetting.text3 == 'custom'
                        ? extras.agendaSetting.fontTilt3 == 'on'
                          ? 'italic'
                          : 'normal'
                        : '',
                    'font-Weight':
                      item.agendaDate == currentId
                        ? extras.agendaSetting.text4 == 'custom'
                          ? extras.agendaSetting.fontWeight4 == 'on'
                            ? 'bolder'
                            : ''
                          : ''
                        : extras.agendaSetting.text3 == 'custom'
                        ? extras.agendaSetting.fontWeight3 == 'on'
                          ? 'bolder'
                          : ''
                        : '',
                  }"
                >
                  {{
                    extras.agendaSetting.type == "en"
                      ? "DAY" + (index + 1)
                      : "第" + (index + 1) + "天"
                  }}
                </div>
                <span
                  :style="{
                    color:
                      item.agendaDate == currentId
                        ? extras.agendaSetting.textActive == 'custom'
                          ? extras.agendaSetting.fontColor2 + ' !important'
                          : ''
                        : extras.agendaSetting.text == 'custom'
                        ? extras.agendaSetting.fontColor
                        : '',
                    'font-size':
                      item.agendaDate == currentId
                        ? extras.agendaSetting.textActive == 'custom'
                          ? extras.agendaSetting.fontSize2 + 'px'
                          : ''
                        : extras.agendaSetting.text == 'custom'
                        ? extras.agendaSetting.fontSize + 'px'
                        : '',
                    'font-style':
                      item.agendaDate == currentId
                        ? extras.agendaSetting.textActive == 'custom'
                          ? extras.agendaSetting.fontTilt2 == 'on'
                            ? 'italic'
                            : 'normal'
                          : ''
                        : extras.agendaSetting.text == 'custom'
                        ? extras.agendaSetting.fontTilt == 'on'
                          ? 'italic'
                          : 'normal'
                        : '',
                    'font-Weight':
                      item.agendaDate == currentId
                        ? extras.agendaSetting.textActive == 'custom'
                          ? extras.agendaSetting.fontWeight2 == 'on'
                            ? 'bolder'
                            : ''
                          : ''
                        : extras.agendaSetting.text == 'custom'
                        ? extras.agendaSetting.fontWeight == 'on'
                          ? 'bolder'
                          : ''
                        : '',
                  }"
                  >{{ item.agendaDate | formatDateNew }}</span
                >
              </div>
            </swiper-slide>
          </swiper>
          <div
            v-if="agendas.length < 5 && agendas.length > 1"
            class="pc-metting-time new auto-flex"
          >
            <div
              class="date-new"
              :class="{
                'cursor-default': isSetting == 1,
                active: item.agendaDate == currentId,
                'tab-length2': agendas.length == 2,
                'tab-length3': agendas.length == 3,
                'tab-length4': agendas.length == 4,
              }"
              :style="{
                background:
                  item.agendaDate == currentId
                    ? extras.agendaSetting.angendaDayBgActive == 'src'
                      ? 'url(' + extras.agendaSetting.src + ')'
                      : extras.agendaSetting.color
                    : extras.agendaSetting.angendaDayBg == 'src'
                    ? 'url(' + extras.agendaSetting.imgUrl + ')'
                    : extras.agendaSetting.color2,
              }"
              v-for="(item, index) in agendas"
              :key="index"
            >
              <div class="date-cnt-new" @click="DayClick(item)">
                <div
                  class="title"
                  :style="{
                    color:
                      item.agendaDate == currentId
                        ? extras.agendaSetting.text4 == 'custom'
                          ? extras.agendaSetting.fontColor4 + ' !important'
                          : ''
                        : extras.agendaSetting.text3 == 'custom'
                        ? extras.agendaSetting.fontColor3
                        : '',
                    'font-size':
                      item.agendaDate == currentId
                        ? extras.agendaSetting.text4 == 'custom'
                          ? extras.agendaSetting.fontSize4 + 'px'
                          : ''
                        : extras.agendaSetting.text3 == 'custom'
                        ? extras.agendaSetting.fontSize3 + 'px'
                        : '',
                    'font-style':
                      item.agendaDate == currentId
                        ? extras.agendaSetting.text4 == 'custom'
                          ? extras.agendaSetting.fontTilt4 == 'on'
                            ? 'italic'
                            : 'normal'
                          : ''
                        : extras.agendaSetting.text3 == 'custom'
                        ? extras.agendaSetting.fontTilt3 == 'on'
                          ? 'italic'
                          : 'normal'
                        : '',
                    'font-Weight':
                      item.agendaDate == currentId
                        ? extras.agendaSetting.text4 == 'custom'
                          ? extras.agendaSetting.fontWeight4 == 'on'
                            ? 'bolder'
                            : ''
                          : ''
                        : extras.agendaSetting.text3 == 'custom'
                        ? extras.agendaSetting.fontWeight3 == 'on'
                          ? 'bolder'
                          : ''
                        : '',
                  }"
                >
                  {{
                    extras.agendaSetting.type == "en"
                      ? "DAY" + (index + 1)
                      : "第" + (index + 1) + "天"
                  }}
                </div>
                <div class="split-str"></div>
                <span
                  :style="{
                    color:
                      item.agendaDate == currentId
                        ? extras.agendaSetting.textActive == 'custom'
                          ? extras.agendaSetting.fontColor2 + ' !important'
                          : ''
                        : extras.agendaSetting.text == 'custom'
                        ? extras.agendaSetting.fontColor
                        : '',
                    'font-size':
                      item.agendaDate == currentId
                        ? extras.agendaSetting.textActive == 'custom'
                          ? extras.agendaSetting.fontSize2 + 'px'
                          : ''
                        : extras.agendaSetting.text == 'custom'
                        ? extras.agendaSetting.fontSize + 'px'
                        : '',
                    'font-style':
                      item.agendaDate == currentId
                        ? extras.agendaSetting.textActive == 'custom'
                          ? extras.agendaSetting.fontTilt2 == 'on'
                            ? 'italic'
                            : 'normal'
                          : ''
                        : extras.agendaSetting.text == 'custom'
                        ? extras.agendaSetting.fontTilt == 'on'
                          ? 'italic'
                          : 'normal'
                        : '',
                    'font-Weight':
                      item.agendaDate == currentId
                        ? extras.agendaSetting.textActive == 'custom'
                          ? extras.agendaSetting.fontWeight2 == 'on'
                            ? 'bolder'
                            : ''
                          : ''
                        : extras.agendaSetting.text == 'custom'
                        ? extras.agendaSetting.fontWeight == 'on'
                          ? 'bolder'
                          : ''
                        : '',
                  }"
                  >{{ item.agendaDate | formatDate }}</span
                >
              </div>
            </div>
          </div>
          <div style="position: relative; overflow: hidden" ref="ScheduleTab">
            <div
              class="m-tab-list-new"
              :class="
                'tab-length' +
                (agendasJson && agendasJson.itemsSubSeminar
                  ? agendasJson.itemsSubSeminar.length +
                    (agendasJson.items.length > 0 ? 1 : 0)
                  : '')
              "
              style="display: inline-block; white-space: nowrap; height: 44px"
              :style="{
                width:
                  agendasJson &&
                  agendasJson.itemsSubSeminar &&
                  agendasJson.itemsSubSeminar.length <
                    (agendasJson.items.length > 0 ? 4 : 5)
                    ? 'auto'
                    : '',
                display:
                  agendasJson &&
                  agendasJson.itemsSubSeminar &&
                  agendasJson.itemsSubSeminar.length <
                    (agendasJson.items.length > 0 ? 4 : 5)
                    ? 'flex'
                    : 'inline-block',
              }"
              v-if="
                extras && extras.subSeminar && extras.subSeminar.display == 1
              "
              v-show="
                (agendasJson &&
                  agendasJson.itemsSubSeminar &&
                  agendasJson.itemsSubSeminar.length > 0) ||
                isSetting == 1
              "
            >
              <div
                class="tab-new u-mr30"
                style="display: inline-block"
                @click="changeAgendaType(0)"
                v-if="agendasJson.items && agendasJson.items.length > 0"
                :class="{
                  'cursor-default': isSetting == 1,
                  active: agendaType === 0,
                }"
              >
                {{ $t("大会日程") }}
                <div class="underline"></div>
              </div>
              <div
                class="tab-new u-mr30"
                style="display: inline-block"
                @click="changeAgendaType(1, index)"
                v-for="(field, index) in agendasJson.itemsSubSeminar"
                :key="index"
                :class="{
                  'cursor-default': isSetting == 1,
                  active: agendaType === 1 && index == agendaType2Index,
                }"
              >
                {{
                  $i18nFlat(
                    subSeminarI18n && subSeminarI18n[field.subSeminarId],
                    "name",
                    field.subSeminarName
                  )
                }}
                <div class="underline"></div>
              </div>
            </div>
          </div>
          <div class="g-schedule-info-new">
            <div class="left-line">
              <div
                class="tab-body-new"
                v-if="agendaType === 0 && agendasJson.items"
              >
                <div
                  class="schedule-item"
                  :class="
                    field.hidden != 1 || extras.mergeAgenda.display == 0
                      ? 'hide-dot'
                      : ''
                  "
                  v-for="(field, index) in agendasJson.items"
                  :key="index"
                  :style="{
                    background:
                      extras.scheduleContent.bgType == 'src'
                        ? 'url(' + extras.scheduleContent.bgImg + ')'
                        : extras.scheduleContent.bgColor,
                  }"
                >
                  <div class="_time">
                    <span
                      v-if="
                        field.hidden != 1 || extras.mergeAgenda.display == 0
                      "
                      :style="{
                        color:
                          extras.scheduleContent.timeText == 'custom'
                            ? extras.scheduleContent.timeFontColor
                            : '',
                        'font-size':
                          extras.scheduleContent.timeText == 'custom'
                            ? extras.scheduleContent.timeFontSize + 'px'
                            : '',
                        'font-style':
                          extras.scheduleContent.timeText == 'custom'
                            ? extras.scheduleContent.timeFontTilt == 'on'
                              ? 'italic'
                              : 'normal'
                            : '',
                        'font-Weight':
                          extras.scheduleContent.timeText == 'custom'
                            ? extras.scheduleContent.timeFontWeight == 'on'
                              ? 'bolder'
                              : ''
                            : '',
                      }"
                      >{{ field.startTime | formatTime }} -
                      {{ field.endTime | formatTime }}</span
                    >
                  </div>
                  <div class="_right">
                    <div
                      class="_title"
                      :style="{
                        color:
                          extras.scheduleContent.nameText == 'custom'
                            ? extras.scheduleContent.nameFontColor
                            : '',
                        'font-size':
                          extras.scheduleContent.nameText == 'custom'
                            ? extras.scheduleContent.nameFontSize + 'px'
                            : '',
                        'font-style':
                          extras.scheduleContent.nameText == 'custom'
                            ? extras.scheduleContent.nameFontTilt == 'on'
                              ? 'italic'
                              : 'normal'
                            : '',
                        'font-Weight':
                          extras.scheduleContent.nameText == 'custom'
                            ? extras.scheduleContent.nameFontWeight == 'on'
                              ? 'bolder'
                              : ''
                            : '',
                      }"
                    >
                      {{
                        $i18nField(
                          agendaI18n && agendaI18n[field.agendaId],
                          "name",
                          field.name
                        )
                      }}
                    </div>

                    <div class="remark" v-if="extras.remark.display == 1">
                      {{
                        $i18nField(
                          agendaI18n && agendaI18n[field.agendaId],
                          "remark",
                          field.remark
                        )
                      }}
                    </div>

                    <div class="guest-info">
                      <div
                        class="item"
                        v-for="(guest, index) in field.guests"
                        :key="index"
                      >
                        <span class="name">{{
                          $i18nField(
                            guestsI18n && guestsI18n[guest.seminarGuestId],
                            "name",
                            guest.name
                          )
                        }}</span>
                        <span class="duty" v-if="guest.enterprise"
                          >&nbsp;|&nbsp;{{
                            $i18nField(
                              guestsI18n && guestsI18n[guest.seminarGuestId],
                              "enterprise",
                              guest.enterprise
                            )
                          }}</span
                        >
                        <span class="duty" v-if="guest.duty">
                          |&nbsp;{{
                            $i18nField(
                              guestsI18n && guestsI18n[guest.seminarGuestId],
                              "duty",
                              guest.duty
                            )
                          }}</span
                        >
                        <span class="dunhao">&nbsp;</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="tab-body-new"
                v-if="agendaType === 1 && agendasJson.itemsSubSeminar"
              >
                <div
                  v-for="(field, index) in agendasJson.itemsSubSeminar"
                  :key="index"
                  v-show="agendaType2Index == index"
                >
                  <div v-show="agendaType === 1 && agendasJson.itemsSubSeminar">
                    <div
                      class="schedule-item"
                      :class="
                        item.hidden != 1 || extras.mergeAgenda.display == 0
                          ? 'hide-dot'
                          : ''
                      "
                      v-for="(item, agendaIndex) in field.items"
                      :key="agendaIndex"
                      :style="{
                        background:
                          extras.scheduleContent.bgType == 'src'
                            ? 'url(' + extras.scheduleContent.bgImg + ')'
                            : extras.scheduleContent.bgColor,
                      }"
                    >
                      <div class="_time">
                        <span
                          v-if="
                            item.hidden != 1 || extras.mergeAgenda.display == 0
                          "
                          :style="{
                            color:
                              extras.scheduleContent.timeText == 'custom'
                                ? extras.scheduleContent.timeFontColor
                                : '',
                            'font-size':
                              extras.scheduleContent.timeText == 'custom'
                                ? extras.scheduleContent.timeFontSize + 'px'
                                : '',
                            'font-style':
                              extras.scheduleContent.timeText == 'custom'
                                ? extras.scheduleContent.timeFontTilt == 'on'
                                  ? 'italic'
                                  : 'normal'
                                : '',
                            'font-Weight':
                              extras.scheduleContent.timeText == 'custom'
                                ? extras.scheduleContent.timeFontWeight == 'on'
                                  ? 'bolder'
                                  : ''
                                : '',
                          }"
                          >{{ item.startTime | formatTime }} -
                          {{ item.endTime | formatTime }}</span
                        >
                      </div>
                      <div class="_right">
                        <div
                          class="_title"
                          :style="{
                            color:
                              extras.scheduleContent.nameText == 'custom'
                                ? extras.scheduleContent.nameFontColor
                                : '',
                            'font-size':
                              extras.scheduleContent.nameText == 'custom'
                                ? extras.scheduleContent.nameFontSize + 'px'
                                : '',
                            'font-style':
                              extras.scheduleContent.nameText == 'custom'
                                ? extras.scheduleContent.nameFontTilt == 'on'
                                  ? 'italic'
                                  : 'normal'
                                : '',
                            'font-Weight':
                              extras.scheduleContent.nameText == 'custom'
                                ? extras.scheduleContent.nameFontWeight == 'on'
                                  ? 'bolder'
                                  : ''
                                : '',
                          }"
                        >
                          {{
                            $i18nField(
                              agendaI18n && agendaI18n[item.agendaId],
                              "name",
                              item.name
                            )
                          }}
                        </div>
                        <div class="remark" v-if="extras.remark.display == 1">
                          {{
                            $i18nField(
                              agendaI18n && agendaI18n[item.agendaId],
                              "address",
                              item.address
                            )
                          }}
                        </div>
                        <div class="guest-info">
                          <div
                            class="item"
                            v-for="(guest, index) in item.guests"
                            :key="index"
                          >
                            <span class="name">{{
                              $i18nField(
                                guestsI18n && guestsI18n[guest.seminarGuestId],
                                "name",
                                guest.name
                              )
                            }}</span>

                            <span class="duty" v-if="guest.enterprise"
                              >&nbsp;|&nbsp;{{
                                $i18nField(
                                  guestsI18n &&
                                    guestsI18n[guest.seminarGuestId],
                                  "enterprise",
                                  guest.enterprise
                                )
                              }}</span
                            >
                            <span class="duty" v-if="guest.duty">
                              |&nbsp;{{
                                $i18nField(
                                  guestsI18n &&
                                    guestsI18n[guest.seminarGuestId],
                                  "duty",
                                  guest.duty
                                )
                              }}</span
                            >
                            <span class="dunhao">&nbsp;</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="m-nodata-body" v-if="agendas.length == 0">
          <img src="@/assets/images/nodata.png" />
          <div class="m-nodata">{{ $t("暂无数据") }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Title from "./Title.vue";
import { URLS } from "fire-wind-water";
import IScroll from "iscroll";
import i18nMixin from "../../mixins/i18n";
import { tMixin } from "../../utils/i18n-t";

export default {
  name: "Header",
  mixins: [i18nMixin, tMixin],
  components: {
    Title,
  },
  props: {
    agendas: [],
    extras: Object,
    agendaI18n: Object,
    guestsI18n: Object,
    subSeminarI18n: Object,
  },
  data() {
    return {
      title: "会议日程",
      num: 0,
      isSetting: 0,
      agendaType: 0,
      currentId: "",
      agendasDates: [],
      agendasJson: [],
      agendaType2Index: -1,
      swiperOptions: {
        slidesPerView: "4",
        grabCursor: true,
        setWrapperSize: true, //使用flexbox布局(display: flex)
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
      },
    };
  },
  created() {
    if (URLS.getURL("isSetting") == 1) {
      this.isSetting = 1;
    }
  },
  mounted() {
    if (this.agendas.length > 0) {
      this.agendasJson = this.formatAgendaJson(this.agendas[0]);
      this.agendasJson.itemsSubSeminar = this.agendas[0]
        ? this.formatSubSeminarAgendaJson(this.agendas[0].itemsSubSeminar)
        : [];
      this.currentId = this.agendas[0].agendaDate;
      if (this.agendasJson.items.length == 0) {
        //主会场没有日程
        this.changeAgendaType(1, 0);
      }
      this.$nextTick(() => {
        new IScroll(this.$refs.ScheduleTab, {
          mouseWheel: false, // 鼠标滚轮控制
          scrollbars: false, //滚动条的显示
          scrollX: true,
          scrollY: false,
        });
      });
    }
  },

  methods: {
    changeAgendaType(type, index) {
      if (URLS.getURL("isSetting") == 1) {
        return;
      }
      this.agendaType = type;
      if (type == 0) {
        this.agendaType2Index = -1;
      } else {
        this.agendaType2Index = index;
      }
    },
    DayClick(item) {
      if (URLS.getURL("isSetting") == 1) {
        return;
      }
      //this.num = index;

      this.agendaType = 0;
      this.agendasJson = this.formatAgendaJson(item);

      this.currentId = item.agendaDate;
      this.agendasJson.itemsSubSeminar = item
        ? this.formatSubSeminarAgendaJson(item.itemsSubSeminar)
        : [];
      if (item.items.length == 0) {
        //主会场没有日程
        this.changeAgendaType(1, 0);
      }
      this.$nextTick(() => {
        new IScroll(this.$refs.ScheduleTab, {
          mouseWheel: false, // 鼠标滚轮控制
          scrollbars: false, //滚动条的显示
          scrollX: true,
          scrollY: false,
        });
      });
    },

    formatAgendaJson(items) {
      // eslint-disable-next-line no-empty
      let agenda = [];
      for (let i = 0; i < items.items.length; i++) {
        let AgendaStr = this.getAgendaDate(
          items.items[i].startTime,
          items.items[i].endTime
        );
        if (agenda.indexOf(AgendaStr) !== -1) {
          items.items[i].hidden = 1;
        } else {
          agenda.push(AgendaStr);
          items.items[i].hidden = 0;
        }
      }

      if (items.itemsSubSeminar && items.itemsSubSeminar.length > 0) {
        items.itemsSubSeminar = this.formatSubSeminarAgenda(items);
      }

      return items;
    },

    formatSubSeminarAgenda(items) {
      for (let i = 0; i < items.itemsSubSeminar.length; i++) {
        items.itemsSubSeminar[i] = this.formatAgendaJson(
          items.itemsSubSeminar[i]
        );
      }
      return items.itemsSubSeminar;
    },
    formatSubSeminarAgendaJson(items) {
      // eslint-disable-next-line no-empty

      for (let i = 0; i < items.length; i++) {
        let agenda = [];
        for (let j = 0; j < items[i].items.length; j++) {
          let AgendaStr = this.getAgendaDate(
            items[i].items[j].startTime,
            items[i].items[j].endTime
          );
          if (agenda.indexOf(AgendaStr) !== -1) {
            items[i].items[j].hidden = 1;
          } else {
            agenda.push(AgendaStr);
            items[i].items[j].hidden = 0;
          }
        }
      }
      return items;
    },
    getAgendaDate(startTime, endTime) {
      return startTime + "_" + endTime;
    },
  },
};
</script>

<style lang="scss" scoped>
.swiper-wrapper {
  justify-content: center;
}
</style>
